import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from 'react-router-dom';
import { WebStorageStateStore } from 'oidc-client-ts'; // Import WebStorageStateStore
import { UserProvider } from "./context/UserContext"; // Import UserProvider


const oidcConfig = {
  authority: "https://cognito-idp.eu-north-1.amazonaws.com/eu-north-1_0CvSTxc8b",
  client_id: "6025mbahv0jiru600106dqoues",
  redirect_uri: import.meta.env.VITE_REDIRECT_URI || "http://localhost:3000/user-management",
  response_type: "code",
  scope: "email openid phone profile",
  automaticSilentRenew: true, // Enable silent renew
  silentRedirectUri: `${window.location.origin}/silent-renew.html`, // Add silent renew URI
  loadUserInfo: true, // Load user info after authentication
};

// Configure userStore to persist user data in localStorage
// const cognitoAuthConfig: AuthProviderProps = {
//   ...oidcConfig,
//   userStore: new WebStorageStateStore({ store: window.localStorage }),
// };
// same as above .TS
const cognitoAuthConfig = {
  ...oidcConfig,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};


// const onSigninCallback = (_user) => {
//   window.history.replaceState({}, document.title, window.location.pathname);
// };
//New version below:
const onSigninCallback = async () => {
  window.history.replaceState({}, document.title, window.location.pathname);
  console.log("User signed in! Fetching user details...");
  // await getDeets(); // Fetch user details on login
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// wrap the application with AuthProvider
root.render(
  <BrowserRouter>
    <React.StrictMode>
      {/* <AuthProvider {...cognitoAuthConfig}> // new version below*/ }
      <AuthProvider {...cognitoAuthConfig} onSigninCallback={onSigninCallback}>
        <UserProvider>
          <App />
        </UserProvider>
      </AuthProvider>
    </React.StrictMode>
  </BrowserRouter>
);



















// import React from "react";
// import ReactDOM from "react-dom/client";
// import App from "./App";
// import { AuthProvider } from "react-oidc-context";
// import { BrowserRouter } from 'react-router-dom';

// const cognitoAuthConfig = {
//   authority: "https://cognito-idp.eu-north-1.amazonaws.com/eu-north-1_0CvSTxc8b",
//   client_id: "6025mbahv0jiru600106dqoues",
//   redirect_uri: "http://localhost:3000/user-management",
//   response_type: "code",
//   scope: "email openid phone profile",
// };


// const oidcConfig: AuthProviderProps = {
//   ...
//   userStore: new WebStorageStateStore({ store: window.localStorage }),
// };

// const root = ReactDOM.createRoot(document.getElementById("root"));

// // wrap the application with AuthProvider
// root.render(
//   <BrowserRouter>
//     <React.StrictMode>
//       <AuthProvider {...cognitoAuthConfig}>
//         <App />
//       </AuthProvider>
//     </React.StrictMode>
//   </BrowserRouter>
// );

